import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import messages from '../messages'

const Ul = styled.ul`
  padding-left: 0;
`
const Li = styled.li`
  list-style: none;
  box-shadow: 0px 1px 6px rgba(0,0,0,0.2);
  margin: 15px;
`
const Main = styled.div`
  border-radius: 5px;
  padding: 20px 20px 10px 20px;
`
const Title = styled.h4`
  margin: 0;
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 16px;
`
const Time = styled.p`
  color: lightgray;
`
const Description = styled.div`
  line-height: 20px;
  font-size: 13px;
  margin-bottom: 10px;
  white-space: pre-wrap;
`
const Price = styled.div`
  font-size: 16px;
  margin-top: 15px;
  margin-bottom: 15px;
  color: ${props => (props.type === 'entitlement' ? 'red' : 'black')};
  font-weight: 700;
  line-height: 14px;
  &:after {
    content: "${props => (props.locale === 'fr' ? '$' : '')}";
  }
  &:before {
    content: "${props => computeContent(props)}";
}
`
const StyledTax = styled.span`
  font-size: 12px;
`
const StyledAdditionalDetails = styled.div`
  padding: 10px;
  border-top: solid 1px lightgray;
`
const Toggle = styled.button`
  background-color: white;
  border: none;
  padding: 0;
  margin-left: 2px;
  user-select: none;

  &:hover {
    cursor: pointer;
  }
  &:after {
    font-family: "bbyc-crm-covert-app-icon-fonts" !important;
    content: "${props => (props.expanded ? 'g' : 'a')}";
    vertical-align: text-bottom;
    margin-left: 3px;
  }
`
const Taxes = () => <StyledTax>+ taxes</StyledTax>

const computeContent = props => {
  if (props.type === 'entitlement' && props.locale === 'en') {
    return '- $'
  } else if (props.type !== 'entitlement' && props.locale === 'en') {
    return '$'
  }
  return ''
}

export default class extends Component {
  static propTypes = {
    cartItem: PropTypes.object,
    type: PropTypes.string,
    formattedPrice: PropTypes.object,
    locale: PropTypes.string,
  }
  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
    }
  }

  handleToggle = toggle => {
    this.setState({ expanded: toggle })
  }

  render() {
    const {
      props: {
        cartItem: {
          sku,
          price,
          name,
          description,
          additionalDescription = '',
          time = '',
          isTaxesIncluded = false,
        },
        type,
        formattedPrice,
        locale,
      },
      state: { expanded },
    } = this
    return (
      <Li key={sku}>
        <Main>
          <Title>{name}</Title>
          <Description>{description}</Description>
          {!!time && <Time>{time}</Time>}
          <Price type={type} locale={locale}>
            {formattedPrice} {!!isTaxesIncluded && <Taxes />}
          </Price>
        </Main>

        {!!additionalDescription && (
          <StyledAdditionalDetails>
            <Toggle
              onClick={() => this.handleToggle(!expanded)}
              expanded={expanded}
            >
              <FormattedMessage {...messages.additionalDetails} />
            </Toggle>

            {expanded && <p>{additionalDescription}</p>}

            {expanded && <p>{additionalDescription}</p>}
          </StyledAdditionalDetails>
        )}
      </Li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Cart/components/CartTile.js